export const ADD_PROJECT = 'ADD_PROJECT';
export const UPDATE_EDITED_PROJECT = 'UPDATE_EDITED_PROJECT';
export const REMOVE_PROJECT = 'REMOVE_PROJECT';
export const SET_PROJECTS = 'SET_PROJECTS';
